import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'toolbar-views.all-entries-view-name-modified': {
    id: 'toolbar-views.all-entries-view-name-modified',
    defaultMessage: 'All entries (edited)',
    description:
      'The name of the default view for all entries in the table with an extra indication to let the user know if it has been modified.',
  },
  'unsaved-view-changes-banner.add-as-new-view-button': {
    id: 'unsaved-view-changes-banner.add-as-new-view-button',
    defaultMessage: 'Add as new view',
    description: 'Button that creates a new view based on the current view settings',
  },
  'unsaved-view-changes-banner.content': {
    id: 'unsaved-view-changes-banner.content',
    defaultMessage:
      '<strong>This view has unsaved changes.</strong> Save to keep your changes and update the view for everyone.',
    description:
      'Banner indicating that the current view has changes applied that have not been saved yet',
  },
  'unsaved-view-changes-banner.content-legacy-unsaved-view': {
    id: 'unsaved-view-changes-banner.content-legacy-unsaved-view',
    defaultMessage:
      '<strong>This view has unsaved changes.</strong> Add as a new view to save changes.',
    description:
      'Banner on an "unsaved" view indicating that the current view has changes applied that have not been saved yet',
  },
  'unsaved-view-changes-banner.content-locked': {
    id: 'unsaved-view-changes-banner.content-locked',
    defaultMessage:
      'The database structure is locked, so changes made to this view will not save. Unlock structure to edit view.',
    description:
      'Banner on a locked database indicating that the current view has changes applied that have not been saved yet',
  },
  'unsaved-view-changes-banner.content-previous-version': {
    id: 'unsaved-view-changes-banner.content-previous-version',
    defaultMessage:
      'You are viewing a previous version of the database, so changes made to this view will not save.',
    description:
      'Banner shown when viewing a previous version of the current database indicating that the current view has changes applied that have not been saved yet',
  },
  'unsaved-view-changes-banner.content-read-only': {
    id: 'unsaved-view-changes-banner.content-read-only',
    defaultMessage: 'You need edit access to the database to save changes to this view.',
    description:
      'Banner on a read-only database indicating that the current view has changes applied that have not been saved yet',
  },
  'unsaved-view-changes-banner.discard-changes-button': {
    id: 'unsaved-view-changes-banner.discard-changes-button',
    defaultMessage: 'Discard',
    description:
      'Button to discard any unsaved changes to the current view that have been applied',
  },
  'unsaved-view-changes-banner.save-button': {
    id: 'unsaved-view-changes-banner.save-button',
    defaultMessage: 'Save changes',
    description:
      'Button to save any unsaved changes to the current view that have been applied',
  },
  'unsaved-view-changes-banner.split-button-label': {
    id: 'unsaved-view-changes-banner.split-button-label',
    defaultMessage: 'More view settings options',
    description:
      'Label on split portion of "Save changes" button that reveals a dropdown menu of additional options',
  },
  'unsaved-view-changes-banner.split-button-menu-item.add-as-new-view': {
    id: 'unsaved-view-changes-banner.split-button-menu-item.add-as-new-view',
    defaultMessage: 'Add as new view',
    description:
      'Menu item option that creates a new view based on the current view settings',
  },
  'view-settings-panel.title': {
    id: 'view-settings-panel.title',
    defaultMessage: 'View settings',
    description: 'The title of the view settings panel.',
  },
  'view-settings-panel.close.tooltip-text': {
    id: 'view-settings-panel.close.tooltip-text',
    defaultMessage: 'Close view settings without updating',
    description: 'The tooltip text for the close button in the view settings panel.',
  },
  'view-settings-panel.delete': {
    id: 'view-settings-panel.delete',
    defaultMessage: 'Delete view',
    description:
      'The aria label for the delete button and tooltip in the view settings panel which deletes the selected view.',
  },
  'view-settings.copy-link': {
    id: 'view-settings.copy-link',
    defaultMessage: 'Copy link to view',
    description:
      'The aria label for the copy link and tooltip button in the view settings panel which copies a link to the database with the current view active. Also used in the view actions dropdown menu in the view tabs and view picker as the text for the "Copy link" dropdown option, and in the view picker as the aria label and tooltip text for the copy link button.',
  },
  'view-settings-panel.back': {
    id: 'view-settings-panel.back',
    defaultMessage: 'Back to view settings',
    description:
      'The aria label and the tooltip text for the back button in the view settings panel.',
  },
  'view-settings-panel.back.content-wrapper-redesign': {
    id: 'view-settings-panel.back.content-wrapper-redesign',
    defaultMessage: 'Back',
    description:
      'The aria label and the tooltip text for the back button in the view settings panel.',
  },
  'view-settings-panel.name-view-label': {
    id: 'view-settings-panel.name-view-label',
    defaultMessage: 'View name',
    description: 'The label for the view name input field in the view settings panel.',
  },
  'view-settings-panel.name-view-placeholder': {
    id: 'view-settings-panel.name-view-placeholder',
    defaultMessage: 'Name your view',
    description:
      'The placeholder for the view name input field in the view settings panel.',
  },
  'view-settings-panel.unsaved-rename-tooltip': {
    id: 'view-settings-panel.unsaved-rename-tooltip',
    defaultMessage: 'Unsaved views can’t be modified',
    description:
      'The tooltip text displayed when hovering over the rename info icon when the Unsaved view view is selected in the view settings panel.',
  },
  'view-settings-panel.rename-info-label': {
    id: 'view-settings-panel.rename-info-label',
    defaultMessage: 'Rename info',
    description: 'The label for the rename info icon in the view settings panel.',
  },
  'view-settings-panel.save-as-new-view-label': {
    id: 'view-settings-panel.save-as-new-view-label',
    defaultMessage: 'Add as new view',
    description: 'The label for the add as new button in the view settings panel.',
  },
  'view-settings-panel.update-view-label': {
    id: 'view-settings-panel.update-view-label',
    defaultMessage: 'Save changes',
    description: 'The label for the update view button in the view settings panel.',
  },
  'view-settings-panel.update-view-flag-body': {
    id: 'view-settings-panel.update-view-flag-body',
    defaultMessage: '<strong>{viewName}</strong> view was updated for everyone.',
    description: 'The body text for the view updated flag from the view settings panel.',
  },
  'view-settings-panel.update-view-flag-undo': {
    id: 'view-settings-panel.update-view-flag-undo',
    defaultMessage: 'Undo',
    description:
      'The text associated with the "Undo" button in the view updated flag from the view settings panel.',
  },
  'view-settings-panel-filter.and-filter-type-label': {
    id: 'view-settings-panel-filter.and-filter-type-label',
    defaultMessage: 'and',
    description:
      'The label for displaying the AND filter for the filter picker in the view settings panel',
  },
  'view-settings-panel-filter.and-filter-type-info-text': {
    id: 'view-settings-panel-filter.and-filter-type-info-text',
    defaultMessage: 'All filters must match',
    description:
      'The informative text for displaying the AND filter for the filter picker in the view settings panel',
  },
  'view-settings-panel-filter.or-filter-type-label': {
    id: 'view-settings-panel-filter.or-filter-type-label',
    defaultMessage: 'or',
    description:
      'The label for displaying the OR filter for the filter picker in the view settings panel',
  },
  'view-settings-panel-filter.or-filter-type-info-text': {
    id: 'view-settings-panel-filter.or-filter-type-info-text',
    defaultMessage: 'At least 1 filter must match',
    description:
      'The informative text for displaying the OR filter for the filter picker in the view settings panel',
  },
  'view-settings-panel-filter.header-info-text': {
    id: 'view-settings-panel-filter.header-info-text',
    defaultMessage: 'In this view, show entries where...',
    description:
      'The header text for the filter configuration in the view settings panel',
  },
  'view-settings-panel-filter.edit-filter-cancel-button': {
    id: 'view-settings-panel-filter.edit-filter-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'A button that discards changes of an existing or removes a new filter being edited',
  },
  'view-settings-panel-filter.edit-filter-create-button': {
    id: 'view-settings-panel-filter.edit-filter-create-button',
    defaultMessage: 'Create',
    description:
      'A button that creates a new filter based on the values selected in the form',
  },
  'view-settings-panel-filter.edit-filter-create-heading': {
    id: 'view-settings-panel-filter.edit-filter-create-heading',
    defaultMessage: 'Create filter',
    description: 'The heading of a form used to create a new filter',
  },
  'view-settings-panel-filter.edit-filter-update-button': {
    id: 'view-settings-panel-filter.edit-filter-update-button',
    defaultMessage: 'Update',
    description:
      'A button that updates an existing filter based on the values selected in the form',
  },
  'view-settings-panel-filter.edit-filter-update-heading': {
    id: 'view-settings-panel-filter.edit-filter-update-heading',
    defaultMessage: 'Edit filter',
    description: 'The heading of a form used to edit an existing filter',
  },
  'view-settings-panel-filter.filter-delete-action-label': {
    id: 'view-settings-panel-filter.filter-delete-action-label',
    defaultMessage: 'Delete filter',
    description: 'The label for the icon button that deletes a filter',
  },
  'view-settings-panel-filter.filter-edit-action-label': {
    id: 'view-settings-panel-filter.filter-edit-action-label',
    defaultMessage: 'Edit filter',
    description: 'The label for the icon button that opens the edit mode for the filter',
  },
  'view-settings-panel-filter.filter-show-more-actions-label': {
    id: 'view-settings-panel-filter.filter-show-more-actions-label',
    defaultMessage: 'Show more actions',
    description:
      'The label for the icon button that shows more actions that can be taken on a filter',
  },
  'view-settings-panel-filter.remove-filter-label': {
    id: 'view-settings-panel-filter.remove-filter-label',
    defaultMessage: 'Remove filter',
    description:
      'The tooltip and label on the trashcan icon for removing a filter in the view settings panel',
  },
  'view-settings-panel-filter.select-field-placeholder': {
    id: 'view-settings-panel-filter.select-field-placeholder',
    defaultMessage: 'Select...',
    description: 'The placeholder text for the field selector in the view settings panel',
  },
  'view-settings-panel-filter.select-field-aria-label.non-final': {
    id: 'view-settings-panel-filter.select-field-aria-label.non-final',
    defaultMessage: 'Select field to filter',
    description: 'The accessible label for the field selector in the filter editor',
  },
  'view-settings-panel-filter.select-filter-type-aria-label.non-final': {
    id: 'view-settings-panel-filter.select-filter-type-aria-label.non-final',
    defaultMessage: 'Select filter type',
    description: 'The accessible label for the filter type selector in the filter editor',
  },
  'view-settings-panel-filter.add-filter-button-text': {
    id: 'view-settings-panel-filter.add-filter-button-text',
    defaultMessage: 'Add filter',
    description: 'The text label for the add filter button in the view settings panel',
  },
  'view-settings-panel-filter.filter-button-options-label': {
    id: 'view-settings-panel-filter.filter-button-options-label',
    defaultMessage: 'More filter options',
    description: 'The text label for filter options dropdown',
  },
  'view-settings-panel-filter.add-filter-group-button-text': {
    id: 'view-settings-panel-filter.add-filter-group-button-text',
    defaultMessage: 'Add filter group',
    description:
      'The text label for the add filter group button in the add filter dropdown',
  },
  'view-settings-panel-filter.clear-filters-button-text': {
    id: 'view-settings-panel-filter.clear-filters-button-text',
    defaultMessage: 'Clear all',
    description: 'The text label for the clear filters button in the view settings panel',
  },
  'view-settings-panel-filter.filter-group-heading': {
    id: 'view-settings-panel-filter.filter-group-heading',
    defaultMessage: 'Group {identifier}',
    description: 'The header text for a filter group',
  },
  'view-settings.filter.filter-text': {
    id: 'view-settings.filter.filter-text',
    defaultMessage: 'Filter',
    description:
      'The text for the filter configuration in the view settings panel (shown in the overview page of the panel as well as on the Filter screen) and for the Filter button in the toolbar.',
  },
  'view-settings-panel.filter.filter-count': {
    id: 'view-settings-panel.filter.filter-count',
    defaultMessage: '{n, plural, one {# filter} other {# filters}}',
    description:
      'The text for the filter count in the filter configuration in the view settings panel.',
  },
  'view-settings.sort.add-sort-button': {
    id: 'view-settings.sort.add-sort-button',
    defaultMessage: 'Add sort',
    description:
      'The text on the button in the Sort panel in View Settings to add a new "sort by" field',
  },
  'view-settings.sort.clear-all-button': {
    id: 'view-settings.sort.clear-all-button',
    defaultMessage: 'Clear all',
    description:
      'The text on the button in the Sort panel in View Settings to clear all "sort by" fields',
  },
  'view-settings-panel.sort.sort-count': {
    id: 'view-settings-panel.sort.sort-count',
    defaultMessage: '{n, plural, one {# sorted} other {# sorted}}',
    description:
      'The text for the count of fields the view is sorted by in the sort configuration in the view settings panel.',
  },
  'view-settings.sort.sort-text': {
    id: 'view-settings.sort.sort-text',
    defaultMessage: 'Sort',
    description:
      'The text for the sort configuration in the view settings panel (shown in the overview page of the panel as well as on the Sort screen) and for the Sort button in the toolbar.',
  },
  'view-settings.sort.description': {
    id: 'view-settings.sort.description',
    defaultMessage:
      'Entries are sorted in the order listed. Change order from the more menu.',
    description: 'Description of how the Sort panel in View Settings works',
  },
  'view-settings.hide-field.field-text': {
    id: 'view-settings.hide-field.field-text',
    defaultMessage: 'Hide field',
    description:
      'The text for the hide field configuration in the view settings panel (shown in the overview page of the panel as well as on the Hide field screen) and for the Hide field button in the toolbar.',
  },
  'view-settings.hide-field.field-text-truncated': {
    id: 'view-settings.hide-field.field-text-truncated',
    defaultMessage: 'Hide',
    description:
      'The text for the hide field configuration in the Hide field button in the toolbar, truncated for the native embed mode.',
  },
  'view-settings.group.group-text': {
    id: 'view-settings.group.group-text',
    defaultMessage: 'Group',
    description: 'The text for the header in group panel.',
  },
  'view-settings-panel-group.header-info-text': {
    id: 'view-settings-panel-group.header-info-text',
    defaultMessage:
      'Choose a field to group and organize entries. Fields that have multi-select enabled cannot be used to group.',
    description: 'The text for the group panel info shown under the header.',
  },
  'view-settings-panel-group.sort-by-dropdown-text': {
    id: 'view-settings-panel-group.sort-by-dropdown-text',
    defaultMessage: 'Sort by',
    description: 'The text for the group panel sort by dropdown menu.',
  },
  'view-settings-panel-group.sort-by-text-value-ascending-label': {
    id: 'view-settings-panel-group.sort-by-text-value-ascending-label',
    defaultMessage: 'A → Z',
    description: 'The text for option to sort by text value ascending.',
  },
  'view-settings-panel-group.sort-by-text-value-descending-label': {
    id: 'view-settings-panel-group.sort-by-text-value-descending-label',
    defaultMessage: 'Z → A',
    description: 'The text for option to sort by text value descending.',
  },
  'view-settings-panel-group.sort-by-numerical-value-ascending-label': {
    id: 'view-settings-panel-group.sort-by-numerical-value-ascending-label',
    defaultMessage: 'Ascending',
    description: 'The text for option to sort by numerical value ascending.',
  },
  'view-settings-panel-group.sort-by-numerical-value-descending-label': {
    id: 'view-settings-panel-group.sort-by-numerical-value-descending-label',
    defaultMessage: 'Descending',
    description: 'The text for option to sort by numerical value descending.',
  },
  'view-settings-panel-group.sort-by-checkbox-ascending-label': {
    id: 'view-settings-panel-group.sort-by-checkbox-ascending-label',
    defaultMessage: 'Unchecked first',
    description:
      'The label for ascending group sort when grouping by a checkbox field (unchecked first).',
  },
  'view-settings-panel-group.sort-by-checkbox-descending-label': {
    id: 'view-settings-panel-group.sort-by-checkbox-descending-label',
    defaultMessage: 'Checked first',
    description:
      'The label for descending group sort when grouping by a checkbox field (checked first).',
  },
  'view-settings-panel-group.sort-by-date-value-ascending-label': {
    id: 'view-settings-panel-group.sort-by-date-value-ascending-label',
    defaultMessage: 'Oldest first',
    description: 'The text for option to sort by date value ascending.',
  },
  'view-settings-panel-group.sort-by-date-value-descending-label': {
    id: 'view-settings-panel-group.sort-by-date-value-descending-label',
    defaultMessage: 'Newest first',
    description: 'The text for option to sort by date value descending.',
  },
  'view-settings-panel-group.sort-by-manual-label': {
    id: 'view-settings-panel-group.sort-by-manual-label',
    defaultMessage: 'Manual',
    description: 'The text for option to sort manually.',
  },
  'view-settings-panel-group.sort-by-manual-no-value-group-text': {
    id: 'view-settings-panel-group.sort-by-manual-no-value-group-text',
    defaultMessage: 'No {fieldname}',
    description: 'Text corresponding to empty value for the field being grouped by',
  },
  'view-settings-panel-group.add-group-button-text': {
    id: 'view-settings-panel-group.add-group-button-text',
    defaultMessage: 'Add group',
    description: 'The text label for the add group button when no group is selected.',
  },
  'view-settings-panel-group.group-by-label': {
    id: 'view-settings-panel-group.group-by-label',
    defaultMessage: 'Group by',
    description: 'The text label for the group by dropdown.',
  },
  'view-settings-panel-group.group-by-aria-label.non-final': {
    id: 'view-settings-panel-group.group-by-aria-label.non-final',
    defaultMessage: 'Select field to group by',
    description: 'The accessible label for the group by field selector.',
  },
  'view-settings-panel-group.no-fields-to-group-by': {
    id: 'view-settings-panel-group.no-fields-to-group-by',
    defaultMessage: 'No single-select fields available to group by',
    description: 'The text shown when there are no available fields for grouping.',
  },
  'view-settings-panel-group.configure-groups-title': {
    id: 'view-settings-panel-group.configure-groups-title',
    defaultMessage: 'Configure groups',
    description:
      'The title for the collapsible section containing group configuration options.',
  },

  'view-settings-panel-subgroup.configure-subgroups-title': {
    id: 'view-settings-panel-subgroup.configure-subgroups-title',
    defaultMessage: 'Configure subgroups',
    description:
      'The title for the collapsible section containing subgroup configuration options.',
  },
  'view-settings-panel-subgroup.add-subgroup-button-text': {
    id: 'view-settings-panel-subgroup.add-subgroup-button-text',
    defaultMessage: 'Add subgroup',
    description:
      'The text label for the add subgroup button when no subgroup is selected.',
  },
  'view-settings-panel-subgroup.subgroup-by-label': {
    id: 'view-settings-panel-subgroup.subgroup-by-label',
    defaultMessage: 'Subgroup by',
    description: 'The text label for the subgroup by dropdown.',
  },
  'view-settings-panel-subgroup.search-placeholder': {
    id: 'view-settings-panel-subgroup.search-placeholder',
    defaultMessage: 'Search for a field...',
    description: 'The placeholder text for the field search input in the subgroup popup.',
  },
  'view-settings-panel-subgroup.remove-subgroup-button-text': {
    id: 'view-settings-panel-subgroup.remove-subgroup-button-text',
    defaultMessage: 'Remove subgroup',
    description: 'The text label for the remove subgroup button.',
  },
  'view-settings-panel.hide-field.field-count': {
    id: 'view-settings-panel.hide-field.field-count',
    defaultMessage: '{n, plural, one {# hidden} other {# hidden}}',
    description:
      'The text for the field count in the hide field configuration in the view settings panel.',
  },
  'view-settings-panel.layout.layout-options-text': {
    id: 'view-settings-panel.layout.layout-options-text',
    defaultMessage: '{layoutType} options',
    description: 'The text for the layout configuration in the view settings panel.',
  },
  'view-settings.layout.group-settings.section-title': {
    id: 'view-settings.layout.group-settings.section-title',
    defaultMessage: 'Group by',
    description:
      'The text for the title of the collapsible section containing group settings',
  },
  'view-settings.layout.display-options.section-title': {
    id: 'view-settings.layout.display-options.section-title',
    defaultMessage: 'Display options',
    description:
      'The text for the title of the collapsible section containing display options',
  },
  'view-settings.layout.layout-text': {
    id: 'view-settings.layout.layout-text',
    defaultMessage: '{layoutType} layout',
    description:
      'The text for the table, card or board layout button in the view settings picker buttons in the toolbar, and the aria label for the layout icons in the view tabs and view picker.',
  },
  'view-settings.layout.layout-text-truncated': {
    id: 'view-settings.layout.layout-text-truncated',
    defaultMessage: 'Layout',
    description:
      'The text for the table, card or board layout button in the view settings picker buttons in the toolbar, truncated for the native embed mode.',
  },
  'view-settings.collapse-button': {
    id: 'view-settings.collapse-button',
    defaultMessage: 'Collapse database toolbar',
    description:
      'Accessible label for the button that collapses (hides) the view settings buttons in the toolbar.',
  },
  'view-settings.expand-button': {
    id: 'view-settings.expand-button',
    defaultMessage: 'Expand database toolbar',
    description:
      'Accessible label for the button that expands (shows) the view settings buttons in the toolbar.',
  },
  'layout.table-text': {
    id: 'layout.table-text',
    defaultMessage: 'Table',
    description:
      'The text for the Table layout option. This is shown in the layout picker, layout configuration in the view settings panel, and the view settings buttons.',
  },
  'layout.gallery-text': {
    id: 'layout.gallery-text',
    defaultMessage: 'Gallery',
    description:
      'The text for the Gallery layout option. This is shown in the layout picker, layout configuration in the view settings panel, and the view settings buttons.',
  },
  'layout.board-text': {
    id: 'layout.board-text',
    defaultMessage: 'Board',
    description:
      'The text for the Board layout option. This is shown in the layout picker, layout configuration in the view settings panel,, and the view settings buttons.',
  },
  'layout.calendar-text': {
    id: 'layout.calendar-text',
    defaultMessage: 'Calendar',
    description:
      'The text for the Calendar layout option. This is shown in the layout picker, layout configuration in the view settings panel, and the view settings buttons.',
  },
  'view-settings.layout.layout-heading': {
    id: 'view-settings.layout.layout-heading',
    defaultMessage: 'Layout',
    description:
      'The heading for the layout configuration screen in the view settings panel.',
  },
  'view-settings.layout.card-width.small-text': {
    id: 'view-settings.layout.card-width.small-text',
    defaultMessage: 'Small',
    description: 'The text for the "Small" option in the card width dropdown.',
  },
  'view-settings.layout.card-width.medium-text': {
    id: 'view-settings.layout.card-width.medium-text',
    defaultMessage: 'Medium',
    description: 'The text for the "Medium" option in the card width dropdown.',
  },
  'view-settings.layout.card-width.large-text': {
    id: 'view-settings.layout.card-width.large-text',
    defaultMessage: 'Large',
    description: 'The text for the "Large" option in the card width dropdown.',
  },
  'view-settings.layout.card-size.label': {
    id: 'view-settings.layout.card-size.label',
    defaultMessage: 'Card size',
    description:
      'The label for the card size dropdown for card and board layout options.',
  },
  'view-settings.layout.cover-image.label': {
    id: 'view-settings.layout.cover-image.label',
    defaultMessage: 'Cover image',
    description:
      'The label for the cover image dropdown for card and board layout options',
  },
  'view-settings.layout.cover-image.aria-label.non-final': {
    id: 'view-settings.layout.cover-image.aria-label.non-final',
    defaultMessage: 'Select cover image field',
    description: 'The accessible label for the cover image field selector',
  },
  'view-settings.layout.cover-image.helper-message': {
    id: 'view-settings.layout.cover-image.helper-message',
    defaultMessage: 'Select an image field as the cover for your entries',
    description:
      'The helper message text for the cover field setting for card and board layout options.',
  },
  'view-settings.layout.cover-image.none-option': {
    id: 'view-settings.layout.cover-image.none-option',
    defaultMessage: 'None',
    description:
      'Text for an option in the field dropdown select to display no cover image',
  },
  'view-settings.layout.group-field.error-message': {
    id: 'view-settings.layout.group-field.error-message',
    defaultMessage:
      'Add a tag field to select a grouping. Make sure the tag field you want has multi-select disabled.',
    description:
      'The error message when a database does not have a select field when switching to the board layout.',
  },
  'view-settings.layout.date-field.error-message': {
    id: 'view-settings.layout.date-field.error-message',
    defaultMessage: 'Add a date field to select a date field',
    description:
      'The error message when a database does not have a date field when switching to the calendar layout.',
  },
  'view-settings.layout.group-field.helper-message': {
    id: 'view-settings.layout.group-field.helper-message',
    defaultMessage: 'Make sure the tag field you want has multi-select disabled',
    description: 'The helper message for the group field for board layout.',
  },
  'view-settings.layout.date-field.helper-message': {
    id: 'view-settings.layout.date-field.helper-message',
    defaultMessage: 'Select a date field to display entries on a calendar',
    description: 'The helper message for the date field for calendar layout.',
  },
  'view-settings.layout.group-field.label': {
    id: 'view-settings.layout.group-field.label',
    defaultMessage: 'Select tag field for grouping',
    description: 'The label for the group by dropdown for board layout.',
  },
  'view-settings.layout.date-field.label': {
    id: 'view-settings.layout.date-field.label',
    defaultMessage: 'Select date field',
    description: 'The label for the date field dropdown for calendar layout.',
  },
  'view-settings.layout.group-field.placeholder': {
    id: 'view-settings.layout.group-field.placeholder',
    defaultMessage: 'Select tag field...',
    description: 'The placeholder for the group by dropdown for board layout.',
  },
  'view-settings.layout.date-field.placeholder': {
    id: 'view-settings.layout.date-field.placeholder',
    defaultMessage: 'Select date field...',
    description: 'The placeholder for the date field dropdown for calendar layout.',
  },
  'view-settings.all-entries-view-name': {
    id: 'view-settings.all-entries-view-name',
    defaultMessage: 'All entries',
    description:
      'The name of the default view that indicates it includes all entries in the table.',
  },
  'view-rename.unique-view-requirement': {
    id: 'view-rename.unique-view-requirement',
    defaultMessage: 'A unique view name is required',
    description: 'The error message displayed when a view name is not unique.',
  },
  'view-settings-fields.heading.hidden': {
    id: 'view-settings-fields.heading.hidden',
    defaultMessage: 'Hidden',
    description:
      'The heading for the section listing all hidden fields in the view settings panel.',
  },
  'view-settings-fields.heading.shown': {
    id: 'view-settings-fields.heading.shown',
    defaultMessage: 'Shown',
    description:
      'The heading for the section listing all shown fields in the view settings panel.',
  },
  'view-settings-fields.empty-values': {
    id: 'view-settings-fields.empty-values',
    defaultMessage: 'Empty values will be hidden',
    description:
      'Message for footer of view settings panel indicating that empty values will be hidden',
  },
  'view-settings-fields.search-placeholder': {
    id: 'view-settings-fields.search-placeholder',
    defaultMessage: 'Search for specific fields',
    description:
      'The placeholder text for the field search input in the view settings panel.',
  },
  'view-settings-fields.shown.layout-dependent-field-tooltip': {
    id: 'field-settings-picker.hidden-fields.layout-dependent-field-tooltip',
    defaultMessage: 'This view requires this field to be shown',
    description:
      'The tooltip for the icon indicating that field is a required to be shown on a view',
  },
  'view-settings-fields.shown.must-show': {
    id: 'view-settings-fields.shown.must-show',
    defaultMessage: 'Must show',
    description: 'The text that indicates a field must be shown for a view',
  },
  'view-settings-fields.switch.show-all': {
    id: 'view-settings-fields.switch.show-all',
    defaultMessage: 'Show all',
    description: 'The label for the show all fields switch in the view settings panel.',
  },
  'view-settings-fields.switch.hide-all': {
    id: 'view-settings-fields.switch.hide-all',
    defaultMessage: 'Hide all',
    description: 'The label for the hide all fields switch in the view settings panel.',
  },
  'view-settings-panel.no-sorting-option-text': {
    id: 'view-settings-panel.no-sorting-option-text',
    defaultMessage: 'No sorting',
    description: 'The text for the no sorting option in the sort picker.',
  },
  'view-settings-panel.sorting-option-text': {
    id: 'view-settings-panel.sorting-option-text',
    defaultMessage: 'Sort by {field}, {sort}',
    description: 'Screen reader label for the sorting option in the sort picker.',
  },
  'view-settings-panel.save-view': {
    id: 'view-settings-panel.save-view',
    defaultMessage: 'Save view',
    description:
      'The text associated with the "Save view" button used for saving a new view.',
  },
  'view-settings-panel.cancel': {
    id: 'view-settings-panel.cancel',
    defaultMessage: 'Cancel',
    description:
      'The text associated with the "Cancel" button used for canceling a view update.',
  },
  'view-actions.failed-to-copy-error': {
    id: 'view-actions.failed-to-copy-error',
    defaultMessage: 'Failed to copy view link',
    description:
      'The error message text when failing to copy a view link from the copy link button.',
  },
  'view-actions.views-more-label': {
    id: 'view-actions.views-more-label',
    defaultMessage: 'more',
    description: 'The aria label text for the more view actions button.',
  },
  'view-actions.edit-view-text': {
    id: 'view-actions.edit-view-text',
    defaultMessage: 'Edit view',
    description: 'The text associated with the "Edit view" dropdown button text.',
  },
  'view-actions.ask-rovo': {
    id: 'view-actions.ask-rovo',
    defaultMessage: 'Ask Rovo',
    description: 'The text for the Ask Rovo button in the view actions dropdown menu.',
  },
  'view-actions.views-make-default-text': {
    id: 'view-actions.views-make-default-text',
    defaultMessage: 'Make default',
    description: 'The text associated with the "Make default view" dropdown button text.',
  },
  'view-actions.views-make-default-tooltip-text': {
    id: 'view-actions.views-make-default-tooltip-text',
    defaultMessage: 'This view is already the default',
    description:
      'The tooltip text for the "Make default" dropdown option in the view actions dropdown that is shown when the view is currently the default view.',
  },
  'view-actions.views-make-default-flag-body': {
    id: 'view-actions.views-make-default-flag-body',
    defaultMessage:
      'The default view on this database is now <strong>{viewName}</strong> for everyone',
    description:
      'The body text for the flag shown after "Make default" is selected in the view actions dropdown.',
  },
  'view-actions.views-rename-text': {
    id: 'view-actions.views-rename-text',
    defaultMessage: 'Rename',
    description: 'The text associated with the "Rename" dropdown button text.',
  },
  'view-actions.duplicate-view': {
    id: 'view-actions.duplicate-view',
    defaultMessage: 'Duplicate view',
    description:
      'The text for the "Duplicate view" dropdown option in the view actions dropdown menu.',
  },
  'view-actions.delete-view-delete-button': {
    id: 'view-actions.delete-view-delete-button',
    defaultMessage: 'Delete view',
    description:
      'The button text for the delete button in the delete view confirm dialog.',
  },
  'views.add-view-label': {
    id: 'views.add-view-label',
    defaultMessage: 'Add view',
    description:
      'The text to add a new view in the view picker, and the aria-label for the add view button to the right of the view tabs.',
  },
  'views.default-view-icon-label': {
    id: 'views.default-view-icon-label',
    defaultMessage: 'Default view',
    description:
      'The aria label for the default view icon indicator in the view tabs and view picker.',
  },
  'view-actions.move-left': {
    id: 'view-actions.move-left',
    defaultMessage: 'Move left',
    description: 'The button text for "Move left" in the view actions dropdown.',
  },
  'view-actions.move-right': {
    id: 'view-actions.move-right',
    defaultMessage: 'Move right',
    description: 'The button text for "Move right" in the view actions dropdown.',
  },
  'view-actions.move-left-tooltip-text': {
    id: 'view-actions.move-left-tooltip-text',
    defaultMessage: 'This is already the leftmost view',
    description:
      'The tooltip text for "Move left" in the view actions dropdown that is shown when the action is disabled due to the view already being the leftmost view.',
  },
  'view-actions.move-right-tooltip-text': {
    id: 'view-actions.move-right-tooltip-text',
    defaultMessage: 'This is already the rightmost view',
    description:
      'The tooltip text for "Move right" in the view actions dropdown that is shown when the action is disabled due to the view already being the rightmost view.',
  },
  'view-overflow.button-label': {
    id: 'view-overflow.button-label',
    defaultMessage: '{n, plural, one {# more...} other {# more...}}',
    description:
      'The text for the overflow button in the view tabs to indicate that the database has more views.',
  },
  'view-overflow.button-aria-label.non-final': {
    id: 'view-overflow.button-aria-label.non-final',
    defaultMessage: '{n, plural, one {Show # more view} other {Show # more views}}',
    description:
      'The accessible label for the overflow button in the view tabs to indicate that the database has more views.',
  },
  'view-settings.layout.number-entries': {
    id: 'view-settings.layout.number-entries',
    defaultMessage: 'Number entries',
    description: 'The label for the "Number entries" toggle in the view settings panel.',
  },
  'view-settings.layout.display-field-names': {
    id: 'view-settings.display-field-names',
    defaultMessage: 'Display field names',
    description:
      'The label for the "Display field names" toggle in the view settings panel.',
  },
});
